<div class="loaderBody" [style.--spinner-z-index]="spinnerIndexZ()">
  <ng-lottie [options]="options"></ng-lottie>
</div>
